import React from "react";
import EvaEntityCreateContainer from "containers/eva/EvaEntityCreateContainer";

interface EvaEntityCreatePageProps {
  isSkillMode?: boolean;
}

const EvaEntityCreatePage: React.FC<EvaEntityCreatePageProps> = ({ isSkillMode = false }) => {
  return <EvaEntityCreateContainer isSkillMode={isSkillMode} />;
};

export default EvaEntityCreatePage;
